import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import { useData } from '../backend/firebase';

const RouteGuard = ({ children }) => {
  const { navigation, user, loading } = useData();
  const location = useLocation();

  if (loading) return null; // Wait for auth/data to load

  // Find settings for the current page
  const navItem = navigation.find(item => item.link === location.pathname);

  // If the page exists in our settings, is marked invisible, and user is NOT admin...
  if (navItem && navItem.visible === false && !user) {
    // ...kick them back to home
    return <Navigate to="/" replace />;
  }

  // Otherwise, render the page
  return children;
};

export default RouteGuard;